<div class="vehicle-info-header">
    <div class="vehicle-image">
        <img [src]="getImage()" (error)="showMissingImage($event)" alt="image of vehicle being purchased." />
    </div>
    <div class="vehicle-title">
        <div class="info-header">
            <div class="title-wrap">
                <h1 class="vehicle-header-title">{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</h1>
                <p class="vin">VIN: {{ vehicle.vin }}</p>
                <p class="dealer-name">{{ deal.dealershipName }}</p>
            </div>
            <div class="more-vehicle-info">
                <div class="info-table-col">
                    <p class="title">Stock #:</p>
                    <p class="data">
                        {{ vehicle.stockNumber !== '' && vehicle.stockNumber !== null ? vehicle.stockNumber : 'N/A' }}
                    </p>
                </div>
                <div class="info-table-col">
                    <p class="title">Price Point:</p>
                    <p class="data">
                        {{
                            vehicle.vehicleExt.priceInternet !== 0 && vehicle.vehicleExt.priceInternet !== null
                                ? (vehicle.vehicleExt.priceInternet | currency: 'USD')
                                : 'N/A'
                        }}
                    </p>
                </div>
                <div class="info-table-col">
                    <p class="title">Body Style:</p>
                    <p class="data">
                        {{ vehicle.bodyStyle !== '' && vehicle.bodyStyle !== null ? vehicle.bodyStyle : 'N/A' }}
                    </p>
                </div>
                <div class="info-table-col">
                    <p class="title">Ext. Color:</p>
                    <p class="data">
                        {{ vehicle.vehicleExt.exteriorColor !== '' && vehicle.vehicleExt.exteriorColor !== null ? vehicle.vehicleExt.exteriorColor : 'N/A' }}
                    </p>
                </div>
                <div class="info-table-col">
                    <p class="title">Int. Color:</p>
                    <p class="data">
                        {{ vehicle.vehicleExt.interiorColor !== '' && vehicle.vehicleExt.interiorColor !== null ? vehicle.vehicleExt.interiorColor : 'N/A' }}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div (click)="modalToggle()" class="mobile-more-vehicle-details-btn">
        <a>{{ isVehicleInfoActive === false ? 'More Vehicle Details' : 'Hide Vehicle Details' }}</a>
    </div>
</div>

<div *ngIf="isVehicleInfoActive === true" class="mobile-vehicle-info-table">
    <div class="info-table-col">
        <p class="title">Body Style:</p>
        <p class="data">
            {{ vehicle.bodyStyle !== '' && vehicle.bodyStyle !== null ? vehicle.bodyStyle : 'N/A' }}
        </p>
    </div>
    <div class="info-table-col">
        <p class="title">Int. Color:</p>
        <p class="data">
            {{ vehicle.vehicleExt.interiorColor !== '' && vehicle.vehicleExt.interiorColor !== null ? vehicle.vehicleExt.interiorColor : 'N/A' }}
        </p>
    </div>
    <div class="info-table-col">
        <p class="title">Ext. Color:</p>
        <p class="data">
            {{ vehicle.vehicleExt.exteriorColor !== '' && vehicle.vehicleExt.exteriorColor !== null ? vehicle.vehicleExt.exteriorColor : 'N/A' }}
        </p>
    </div>
    <div class="info-table-col">
        <p class="title">Stock #:</p>
        <p class="data">
            {{ vehicle.stockNumber !== '' && vehicle.stockNumber !== null ? vehicle.stockNumber : 'N/A' }}
        </p>
    </div>
</div>
